import type { ActivityCategory } from '../../../store';

export type { ActivityCategory, ActivityLog } from '../../../store';

interface CategoryDef {
  key: ActivityCategory;
  label: string;
  /** `cc-*` color class for the badge. */
  className: string;
}

export const CATEGORIES: CategoryDef[] = [
  { key: 'alerts', label: 'Alerts', className: 'cc-red' },
  { key: 'webplayer', label: 'Webplayer', className: 'cc-blue' },
  { key: 'distribution', label: 'Distribution', className: 'cc-amber' },
  { key: 'comms', label: 'Comms', className: 'cc-green' },
  { key: 'marketplace', label: 'Marketplace', className: 'cc-purple' }
];
